<template>
        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card full-screen >

            <div class="modal-card ">
                    <header class="modal-card-head">
                      <p class="modal-card-title " v-if="kindProps==0" > ComboSet Patho For NonAutomate</p>
                      <p class="modal-card-title " v-if="kindProps==1" > ComboSet Patho For Automate</p>   
                    </header>
                <section class="modal-card-body"  >
                    <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
                    <b-tabs v-model="activeTab">
                        <b-tab-item label="Comboset">
                            <div class="columns">
                                <div class="column">
                                    <nav class="panel">
                                        <div class="panel-heading">
                                            <b-button type="is-success" icon-right="plus" @click="addNewGroup" />
                                            &nbsp;
                                            <b-button type="is-success" @click="saveOrderForGroup" >Save Order Group</b-button>
                                        </div>
                                        <div class="panel-block">
                                            <b-table
                                                    :data="isEmpty ? [] : groupPathoComboset"
                                                    bordered
                                                    striped
                                                    narrowed
                                                    hoverable
                                                    focusable
                                                    mobile-cards
                                                    draggable
                                                    @dragstart="dragstartGroup"
                                                    @drop="dropGroup"
                                                    @dragover="dragoverGroup"
                                                    @dragleave="dragleaveGroup"
                                                    :loading="detailLoading"
                                                    :selected.sync="selectedGrp"  style="width: 100%">


                                                    <b-table-column  label="edit" v-slot="props" >
                                                        <b-button type="is-warning"
                                                                  icon-right="pencil" @click="editGroup(props.row.id,props.row.name)"/>
                                                    </b-table-column>
                                                    <b-table-column  label="delete" v-slot="props" >
                                                        <b-button type="is-danger"
                                                                  icon-right="delete" @click="deleteGroup(props.row.id,props.row.name)"/>
                                                    </b-table-column>
                                                    <b-table-column  label="ชื่อกลุ่ม comboset" v-slot="props" >
                                                        {{ props.row.name }}
                                                    </b-table-column>
                                                    <b-table-column  label="ORDER" :visible=false v-slot="props">
                                                        {{ props.row.order }}
                                                    </b-table-column>
                                                    <b-table-column  label="UUID" :visible=false v-slot="props">
                                                        {{ props.row.uuid }}
                                                    </b-table-column>



                                                <template slot="empty">
                                                    <section class="section">
                                                        <div class="content has-text-grey has-text-centered">
                                                            <p>
                                                                <b-icon
                                                                        icon="emoticon-sad"
                                                                        size="is-large">
                                                                </b-icon>
                                                            </p>
                                                            <p>Nothing here.</p>
                                                        </div>
                                                    </section>
                                                </template>
                                            </b-table>
                                        </div>
                                    </nav>

                                </div>
                                <div class="column">
                                    <nav class="panel">
                                        <div class="panel-heading">
                                            <b-button type="is-success"  icon-right="plus"  @click="showListPart"/>
                                            &nbsp;
                                            <b-button type="is-success"  icon-right="cloud-upload" @click="saveDetail" />
                                            &nbsp;
                                            <p class="is-size-4"> {{displayGrpName}} </p>
                                        </div>
                                        <div class="panel-block">
                                            <b-table
                                                    :data="isEmpty ? [] : detailEachGroupPathoComboset"
                                                    bordered
                                                    striped
                                                    narrowed
                                                    hoverable
                                                    focusable
                                                    mobile-cards
                                                    :loading="detailLoading"
                                                    draggable
                                                    @dragstart="dragstart"
                                                    @drop="drop"
                                                    @dragover="dragover"
                                                    @dragleave="dragleave"

                                                    style="width: 100%" >



                                                    <b-table-column  label="ID" v-slot="props" >
                                                        {{ props.row.idpart }}
                                                    </b-table-column>
                                                    <b-table-column  label="DESCP" v-slot="props">
                                                        {{ props.row.descp }}
                                                    </b-table-column>
                                                    <b-table-column  label="Unit" v-slot="props">
                                                        {{ props.row.unit }}
                                                    </b-table-column>
                                                    <b-table-column  label="Status" v-slot="props">
                                                        <b-icon pack="fas"
                                                                :type="props.row.fresh  ? 'is-success' : 'is-primary'"
                                                                :icon="props.row.fresh  ? 'cloud-upload-alt' : 'cloud'">
                                                        </b-icon>
                                                    </b-table-column>
                                                    <b-table-column  label="SortID" :visible=false v-slot="props">
                                                        {{ props.row.sort_id }}
                                                    </b-table-column>
                                                    <b-table-column  label="uuid" :visible=false v-slot="props">
                                                        {{ props.row.uuid }}
                                                    </b-table-column>
                                                    <b-table-column  label="delete" v-slot="props">
                                                        <b-button type="is-danger"  icon-right="delete" @click="deleteSomeDetail(props.row.uuid )" />
                                                    </b-table-column>



                                                <template slot="empty">
                                                    <section class="section">
                                                        <div class="content has-text-grey has-text-centered">
                                                            <p>
                                                                <b-icon
                                                                        icon="emoticon-sad"
                                                                        size="is-large">
                                                                </b-icon>
                                                            </p>
                                                            <p>Nothing here.</p>
                                                        </div>
                                                    </section>
                                                </template>
                                            </b-table>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </b-tab-item>
                        <b-tab-item label="Search Items">
                            <ListPartsPatho ref="ListPartsPatho" :placeholderTxt="placeholderTxt"  @addItemToDetail="addItemToDetail"/>
                        </b-tab-item>
                    </b-tabs>




                </section>
                <footer class="modal-card-foot">
                    <b-button size="is-medium" type="is-danger"
                              icon-left="close" @click="closeModal">
                        Close
                    </b-button>
                </footer>
            </div>
           <AddEditPathoComboSetGroupName v-if="isAddEditNonAutomateGroupNameModal"
                                        ref="AddEditPathoComboSetGroupName"
                                        :dataToChild="dataToChild"
                                        @close="closeWithNothing"
                                        @closeWithAddNew="closeWithAddNew"
                                        @closeWithEditName="closeWithEditName"/>
        </b-modal>
</template>


<script>
import { mapActions,mapState} from "vuex";
import {getBaseURLforBackEnd,getConfigAxios, genUUID}  from '@/utils.js'
import axios from "axios";
import AddEditPathoComboSetGroupName from "./AddEditPathoComboSetGroupName";
import ListPartsPatho from "./ListPartsPatho";



export default {
    name : "PathoCombosetManagement",
    props:{
         kindProps : Number, // 0 == nonautomate , 1 == automate
    },
    components:{
            ListPartsPatho,
            AddEditPathoComboSetGroupName,
        },
    computed:{
            ...mapState({
               // groupNonautomateRequest : state =>  state.admin.groupNonautomateRequest,
                groupPathoComboset : state =>  state.admin.groupPathoComboset,
               // detailEachGroup : state => state.admin.detailEachGroup,
                detailEachGroupPathoComboset : state => state.admin.detailEachGroupPathoComboset,


                access_token : state => state.master_data.access_token,
            })
    },



    methods:{
            ...mapActions({
                fetchGroupPathoComboset : 'admin/fetchGroupPathoComboset',
                clearGroupPathoComboset : 'admin/clearGroupPathoComboset',
                fetchDetailEachGroupPathoComboset : 'admin/fetchDetailEachGroupPathoComboset',
                clearDetailEachGroupPathoComboset : 'admin/clearDetailEachGroupPathoComboset'
            }),
           deleteSomeDetail(uuid){
                const member = this.detailEachGroupPathoComboset.find(dat => dat.uuid === uuid)

                const memberIndex = this.detailEachGroupPathoComboset.indexOf(member)
                // console.log(memberIndex)
                this.detailEachGroupPathoComboset.splice(memberIndex,1)
           }, 
           addItemToDetail(part){
                // console.log(part)
                part.sort_id = -1
                part.uuid = genUUID(6)
                part.fresh = true
                //
                this.detailEachGroupPathoComboset.push(part)
                //
                this.$buefy.toast.open({
                    message: `Add New Item ${part.descp} into ${this.displayGrpName}`,
                    duration:500
                })
                //
                this.activeTab  = 0





           }, 
           closeWithAddNew(){
                this.isAddEditNonAutomateGroupNameModal = false
                // refresh all
                this.doFetchGroupPathoComboset()
            }, 
           closeWithEditName(datBack){
                // goto change in vuex
                const memberGroup =  this.groupPathoComboset.find(dat => dat.id === datBack.id)
                memberGroup.name = datBack.name
                this.isAddEditNonAutomateGroupNameModal = false
           },
           closeWithNothing(){
                this.isAddEditNonAutomateGroupNameModal = false
                    if( this.selectedGrp !== null) {
                        this.fetchDetailEachGroupPathoComboset( this.selectedGrp.id)
                    }else{
                        if(this.groupPathoComboset.length>0){
                            this.selectedGrp = this.groupPathoComboset[0]
                            this.fetchDetailEachGroupPathoComboset( this.selectedGrp.id)
                        }
                    }
           }, 
           doFetchGroupPathoComboset(){

                const  vm = this
                this.fetchGroupPathoComboset({"kind" : this.kindProps})
                 .then((res)=>{
                     if(res.length>0){
                         vm.selectedGrp = this.groupPathoComboset[0]
                     }
                 })

            },
           showListPart(){
                this.activeTab  =  1
           },
           saveDetail(){
                // make sure order index has make
                this.reMakeIndexSort(this.detailEachGroupPathoComboset)
                //
                //{
                //     "idgrp" : 1,
                //         "parts" : [{"idpart": "100000000005","sort_id": 1},{"idpart": "300000000037","sort_id": 3}]
                // }
                var tmpParts = []
                for (var i = 0; i< this.detailEachGroupPathoComboset.length;i++){
                     const tmp = {
                         "idpart": this.detailEachGroupPathoComboset[i]['idpart'] ,"sort_id" : this.detailEachGroupPathoComboset[i]['sort_id']
                     }
                     tmpParts.push(tmp)
                }


                const datTo ={
                    "idgrp" : this.selectedGrp.id,
                    "parts" : tmpParts
                }

                // console.log(JSON.stringify(datTo))
                const vm = this
                this.isFullScreenLoading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/updatedetailgrouppatho`,datTo,getConfigAxios())
                .then((res)=>{
                    vm.$buefy.toast.open({
                        duration: 1000,
                        message: `${res.data.msg}`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })
                    setTimeout(()=>{
                        vm.isFullScreenLoading = false

                    },1000)

                })
                .catch((err)=>{
                    vm.$buefy.toast.open({
                        duration: 1000,
                        message: `${err.data}`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })
                    vm.isFullScreenLoading = false
                })




           },
           deleteGroup(id,name){


                this.$buefy.dialog.confirm({
                    title: 'Deleting ',
                    message: ` Are you sure you want to <b>delete</b> your group? <b>${name}</b> `,
                    confirmText: 'Delete ',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        //
                        const datTo = {
                            "idgrp": id
                        }
                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                        axios.post(`${getBaseURLforBackEnd()}/api/deletegroupandalldetailpathocomboset`,datTo,getConfigAxios())
                         .then((res)=>{
                             // if success to delete
                             // find in vuex and delete it
                             this.clearDetailEachGroupID()
                             // {
                             //         "id": 2,
                             //         "name": "Biopsy",
                             //         "order": "",
                             //         "uuid": "984825"
                             // },
                             const memberGroup = this.groupPathoComboset.find(dat=>dat.id === id)
                             const memberGroupIndex = this.groupPathoComboset.indexOf(memberGroup)
                             this.groupPathoComboset.splice(memberGroupIndex,1)
                             this.$buefy.toast.open({
                                 message: `Delete ${name} group ${res.data.msg} `,
                                 type: 'is-success',
                                 duration:1200
                             })


                                 this.selectedGrp = null
                                 if(this.groupPathoComboset.length>0) {
                                     this.selectedGrp = this.groupPathoComboset[0]
                                     this.fetchDetailEachGroupID(this.selectedGrp.id)
                                 }

                         })

                         .catch((err)=>{
                     

                             this.$buefy.dialog.alert({
                                 title: 'Error',
                                 message: `Can not delete cause  ${err}` ,
                                 type: 'is-danger',
                                 hasIcon: true,
                                 icon: 'times-circle',
                                 iconPack: 'fa',
                                 ariaRole: 'alertdialog',
                                 ariaModal: true
                             })
                         })





                    }
                })
           },
           closeModal(){
                this.clearGroupPathoComboset()
                this.clearDetailEachGroupPathoComboset()
                this.isComponentModalActive = false
           },
   
            saveOrderForGroup(){
                //console.log(JSON.stringify(this.groupPathoComboset))
                this.reMakeIndexSort(this.groupPathoComboset)
                var tmpArr = []
                this.groupPathoComboset.forEach((dat) =>{
                    tmpArr.push( { "idgrp" : dat.id , "order" : dat.order}  )
                })
                const datTo = {
                    "data" : tmpArr
                }
                console.log(JSON.stringify(datTo))
                const vm = this
                this.isFullScreenLoading = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/makeordergrouppathocomboset`,datTo,getConfigAxios())
                  .then((res)=>{
                      vm.$buefy.toast.open({
                          duration: 1000,
                          message: `${res.data.msg}`,
                          position: 'is-bottom',
                          type: 'is-success'
                      })
                      setTimeout(()=>{
                          vm.isFullScreenLoading = false

                      },1000)
                  })
                .catch((err)=>{
                        vm.$buefy.toast.open({
                        duration: 1000,
                        message: `${err.data}`,
                        position: 'is-bottom',
                        type: 'is-success'
                    })
                    vm.isFullScreenLoading = false
                })
            },
        
        
        
            editGroup(id,name){
                this.dataToChild.name = name
                this.dataToChild.mode = "e"
                this.dataToChild.id = id
                this.isAddEditNonAutomateGroupNameModal = true
            },
            addNewGroup(){
              // console.log('addNewGroup')
                this.dataToChild.kind = this.kindProps
                this.dataToChild.name = ""
                this.dataToChild.mode = "n"
                this.dataToChild.id = ""
                this.isAddEditNonAutomateGroupNameModal = true
            },
 

            dragstart (payload) {
                this.draggingRow = payload.row
                this.draggingRowIndex = payload.index
                payload.event.dataTransfer.effectAllowed = 'copy'
            },
            dragover(payload) {
                payload.event.dataTransfer.dropEffect = 'copy'
                payload.event.target.closest('tr').classList.add('is-selected')
                payload.event.preventDefault()
            },
            dragleave(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                payload.event.preventDefault()
            },
            drop(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                const droppedOnRowIndex = payload.index
                this.$buefy.toast.open({
                    message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                    duration:500
                })

                this.swapArrayElements(this.detailEachGroupPathoComboset , this.draggingRowIndex ,droppedOnRowIndex )
                this.detailEachGroupPathoComboset[droppedOnRowIndex]['uuid'] = genUUID(6)
                this.detailEachGroupPathoComboset[this.draggingRowIndex]['uuid'] = genUUID(6)
            },

            dragstartGroup (payload) {
                this.draggingRow = payload.row
                this.draggingRowIndex = payload.index
                payload.event.dataTransfer.effectAllowed = 'copy'
            },
            dragoverGroup(payload) {
                payload.event.dataTransfer.dropEffect = 'copy'
                payload.event.target.closest('tr').classList.add('is-selected')
                payload.event.preventDefault()
            },
            dragleaveGroup(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                payload.event.preventDefault()
            },
            dropGroup(payload) {
                payload.event.target.closest('tr').classList.remove('is-selected')
                const droppedOnRowIndex = payload.index
                this.$buefy.toast.open({
                    message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                    duration:500
                })

                this.swapArrayElements(this.groupPathoComboset , this.draggingRowIndex ,droppedOnRowIndex )
                this.groupPathoComboset[droppedOnRowIndex]['uuid'] = genUUID(6)
                this.groupPathoComboset[this.draggingRowIndex]['uuid'] = genUUID(6)
            },

            swapArrayElements (arr, indexA, indexB) {
                    // var temp = arr[indexA];
                    // arr[indexA] = arr[indexB];
                    // arr[indexB] = temp;
                    var temp = arr[indexA];
                    arr.splice(indexA,1)
                    arr.splice(indexB,0,temp)
                    this.reMakeIndexSort(arr)
            },
            reMakeIndexSort(arr){
                for(var i = 0;i<arr.length;i++){
                    if('sort_id' in arr[i]){  // for detail
                        arr[i]['sort_id'] = i
                    }
                    else if('order' in arr[i]){  // for group or master
                        arr[i]['order'] = i
                    }
                }
            },






    },
    data(){
        return{
            isFullScreenLoading : false,
            isComponentModalActive : false,
            isEmpty : false,
            selectedGrp : null,
            detailLoading : false,
            draggingRow: null,
            draggingRowIndex: null ,
            displayGrpName : "",
            isListPartsModal : false,
            activeTab : 0,
            isAddEditNonAutomateGroupNameModal : false,
            dataToChild : {name : "", mode : "n" ,id : ""},
            placeholderTxt : "บริการตรวจ Cyto",


            // kind : 0, // 0 == nonautomate , 1 == automate
          
        }
    },

    watch:{
        isComponentModalActive:{
            immediate : true,
            handler: function(val){
                if(val){
                    // console.log(`active with ${this.kindProps}` )
                    this.doFetchGroupPathoComboset()
                }
                 
            }
        },
        selectedGrp: {
            /* eslint-disable no-console */
            handler: function (val) {
                // console.log(val)
                this.detailLoading = true
                const vm = this
                this.fetchDetailEachGroupPathoComboset(val.id)
                    .then(()=>{
                        setTimeout(()=>{vm.detailLoading = false},500)
                    })
                this.displayGrpName = val.name
            }
        }
    },

}
</script>